import { Component, ChangeDetectionStrategy, ViewChild, TemplateRef, NgModule, OnInit } from '@angular/core';
import { startOfDay, endOfDay, isSameDay, isSameMonth, endOfMonth, format } from 'date-fns';
import { Subject } from 'rxjs';
import {
  CalendarA11y,
  CalendarDateFormatter,
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarModule,
  CalendarUtils,
  CalendarView,
  DateAdapter,
  CalendarEventTitleFormatter,
  CalendarCommonModule,
  CalendarMonthModule
} from 'angular-calendar';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { I18nPluralPipe } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ThemePalette } from '@angular/material/core';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PermissionService } from '../../../components/Authentication/services/permission.service';

const colors: any = {
  red: {
    primary: '#EA4C4C',
    secondary: '#EA4C4C',
  },
  blue: {
    primary: '#7BB3F0',
    secondary: '#7BB3F0',
  },
  yellow: {
    primary: '#D4D813',
    secondary: '#D4D813',
  },
  green: {
    primary: '#55AB58',
    secondary: '#55AB58',
  },
  orange: {
    primary: 'orange',
    secondary: 'orange',
  },
  pink: {
    primary: '#FE6BDE',
    secondary: '#FE6BDE',
  },
  dark_blue: {
    primary: '#1d26f0',
    secondary: '#1d26f0',
  },
  dark_yellow: {
    primary: '#FFC107',
    secondary: '#FFC107',
  },
  black: {
    primary: 'black',
    secondary: 'black',
  }
};

const Representaion_data: any = [
  {
    title: 'Present',
    color: '#55AB58'
  },
  {
    title: 'Absent',
    color: '#EA4C4C'
  },
  {
    title: 'Holidays',
    color: '#D4D813'
  },
  {
    title: 'Weekly offs',
    color: '#7BB3F0'
  },
  // {
  //   title: 'Leave Applied',
  //   color: '#FE6BDE'
  // },
  // {
  //   title: 'Leave Approved',
  //   color: '#1d26f0'
  // },
  // {
  //   title: 'Multiple Events',
  //   color: '#FFC107'
  // },
]


@Component({
  selector: 'app-studentattendance',
  standalone: true,
  templateUrl: './studentattendance.component.html',
  styleUrl: './studentattendance.component.scss',
  imports: [
    CommonModule,
    FormsModule,
    MatProgressBarModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    CalendarModule
  ],
  providers: [I18nPluralPipe, CalendarEventTitleFormatter, { provide: DateAdapter, useFactory: adapterFactory }, CalendarDateFormatter, CalendarUtils, CalendarA11y]
})
export class StudentattendanceComponent {
  console = console;
  private year: number = new Date().getFullYear();
  private month: number = new Date().getMonth();
  @ViewChild('modalContent')
  modalContent!: TemplateRef<any>;
  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  Representaion_data: any = Representaion_data;
  total_present_days: any;
  total_absent_days: any;
  color = 'green'
  modalData!: {
    action: string;
    event: CalendarEvent;
  };
  status: string = '';
  actions: CalendarEventAction[] = [
    {
      label: 'sjdkf',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      },
    },
    {
      label: 'snkfd',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.handleEvent('Deleted', event);
      },
    },
  ];
  refresh: Subject<any> = new Subject();
  events: CalendarEvent[] = [];
  activeDayIsOpen: boolean = true;
  attendance_percentage: any;
  actiondata: any;

  constructor(
    private apiservice: ApiservicesService,
    private permissionService: PermissionService,
  ) {
    this.actiondata = this.permissionService.getactiondata();
    this.getstudentattendancedetails()
  }
  ngOnInit(): void {
    // this.getattendancedetails()   
  }

  yearmonth(event: Date) {
    this.events = [];
    let formated = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).format(event);
    this.year = event.getFullYear();
    this.month = event.getMonth();
    this.getstudentattendancedetails();
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      this.viewDate = date;
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }


  getstudentattendancedetails() {
    const monthEnd = endOfMonth(this.viewDate);
    // const month = format(monthEnd, 'yyyy-mm');
    this.apiservice.getstudentattendancedetails(this.year, this.month + 1).subscribe((res: any) => {
      this.attendance_percentage = res.attendance_percentage;
      this.total_present_days = res?.total_present_classes;
      this.total_absent_days = res?.total_absent_classes;
      this.attendance_percentage = res?.attendance_percentage;
      // if(res.code === 200 && res.status === true){
      // res.rows.forEach((item: any, index:number) => {
      res.attendance_data?.forEach((items: any) => {
        this.console.log("items", items)
        // if (items?.status === 'PRESENT') {
        // items?.attendance?.forEach((item: any, index: number) => {
        this.events.push({
          start: startOfDay(items.date),
          // end: endOfDay(item.date),
          title: items.subject_name,
          // status: item.status,
          color: items.status === 'PRESENT' ? colors.green : colors.red,
          draggable: false,
          actions: this.actions,
          meta: {
            id: items.id,
            entity: 'Show contains',
            start_time: items.start_time,
            end_time: items.end_time,
            subject_attendance: items.status,
            status: items.status,
            notes: items.notes ? items.notes : ''
          }
          // });
        });
        // }
        // else {
        //   // items.forEach((item: any, index:number) => {
        //   this.events.push({
        //     start: startOfDay(JSON.stringify(items.year + '-' + items.month + '-' + items.date)),
        //     // end: endOfDay(item.date),
        //     title: ' show contains',
        //     // status: item.status,
        //     color: items?.status === 'PRESENT' ? colors.green : colors.red,
        //     draggable: false,
        //     actions: this.actions,
        //     meta: {
        //       id: items?.id,
        //       entity: 'Show contains',
        //       start_time: items?.start_time,
        //       end_time: items?.end_time,
        //       status: items?.status,
        //       subject_attendance: items?.status,
        //       notes: items?.notes ? items?.notes : ''
        //     }
        //   });

        //   // });
        // }
      })

      res.weekoffs.forEach((item: any, index: number) => {
        this.events.push({
          // id : index,
          start: startOfDay(item.date),
          // end: endOfDay(item.end_date),
          title: 'Week Off',
          color: colors.blue,
          draggable: false,
          actions: this.actions,
          meta: {
            // id: item.id,
            entity: 'Week Off',
            // start_time: item.start_time,
            // end_time: item.end_time,
            status: 'WEEKOFF',
            daytype: 'WEEKOFF',
            notes: 'Week Off'
          }
        });
      });

      res?.holidays?.forEach((item: any, index: number) => {
        this.events.push({
          start: startOfDay(item.date),
          // end: endOfDay(item.date),
          title: item.holiday_type,
          color: colors.yellow,
          draggable: false,
          actions: this.actions,
          meta: {
            id: item.id,
            entity: 'Show contains',
            start_time: item.start_time,
            end_time: item.end_time,
            status: item.status,
            daytype: 'HOLIDAY',
            notes: item?.holiday_name
          }
        });
      });

      res?.leaves_data?.forEach((item: any, index: number) => {
        this.events.push({
          start: startOfDay(item.start_date),
          end: endOfDay(item.end_date),
          title: item.leave_type,
          color: colors.pink,
          draggable: false,
          actions: this.actions,
          meta: {
            id: item.id,
            entity: 'Show contains',
            start_time: item.start_time,
            end_time: item.end_time,
            status: item.status,
            daytype: 'ABSENT',
            notes: item?.leave_type
          }
        });
      });
      this.refresh.next(true);
      // }
    })
  }
}
